<div class="sh-page-header">
    <nav
        *ngIf="(primaryNavigationItems && primaryNavigationItems.length) || (secondaryNavigationItems && secondaryNavigationItems.length)"
        class="sh-page-header__navigation"
    >
        <div class="sh-action-bar">
            <div class="sh-action-bar__group -sh-item-gap -sh-align-left" *ngIf="primaryNavigationItems && primaryNavigationItems.length">
                <sh-icon-link *ngFor="let navigationItem of primaryNavigationItems" [item]="navigationItem" class="sh-action-bar__group__item"></sh-icon-link>
            </div>
            <div class="sh-action-bar__group -sh-item-gap" *ngIf="secondaryNavigationItems && secondaryNavigationItems.length">
                <sh-icon-link *ngFor="let navigationItem of secondaryNavigationItems" [item]="navigationItem" class="sh-action-bar__group__item"></sh-icon-link>
            </div>
        </div>
    </nav>

    <header class="sh-page-header__head">
        <div class="sh-page-header__head__info">
            <div class="sh-page-header__head__info__title">
                <h2 *ngIf="!isSubsection" class="sh-page-title" [class.sh-icon-title]="icon">
                    <svg *ngIf="icon" sh-icon class="sh-icon-title__icon" [size]="iconSize.LARGE" aria-hidden="true" [name]="icon"></svg>
                    {{ title }}
                </h2>
                <h3 *ngIf="isSubsection" class="sh-page-title--subsection" [class.sh-icon-title]="icon">
                    <svg *ngIf="icon" sh-icon class="sh-icon-title__icon" [size]="iconSize.REGULAR" aria-hidden="true" [name]="icon"></svg>
                    {{ title }}
                </h3>

                <div *ngIf="contextItems && contextItems.length" class="sh-page-header__head__info__context">
                    <sh-inline-description-list [items]="contextItems" [fullWidth]="fullWithContext"></sh-inline-description-list>
                </div>
            </div>
        </div>
        <div *ngIf="actionItems && actionItems.length" class="sh-page-header__head__actions">
            <div class="sh-action-group -sh-condense">
                <sh-action-item *ngFor="let item of actionItems" [item]="item" class="sh-action-group__item"></sh-action-item>
            </div>
        </div>
    </header>
</div>
